import { GroupError } from '../../../../GroupStore/Types';
import { T } from '../../../../Translations';

interface Props {
  error: GroupError | { message: string };
}

function ErrorState({ error }: Props) {
  const getMessage = () => {
    // Handle standard Error
    if (error instanceof Error) {
      return error.message;
    }

    // Handle discriminated union by kind
    if ('kind' in error) {
      switch (error.kind) {
        case 'server-error':
          return error.message; // AlreadyTranslatedText
        case 'missing-link-error':
          return `Missing link: ${error.rel}`;
        default:
          // Other error kinds from AppyError, InvalidUrlError
          return 'message' in error ? error.message : 'An error occurred';
      }
    }

    // Fallback for plain objects with message
    return error.message || 'Unable to load group for editing';
  };

  const message = getMessage();

  return (
    <div className="bg-white rounded-lg shadow p-8">
      <div className="text-center py-12">
        <div className="text-red-600 text-xl font-semibold mb-4">
          <T kind="Something went wrong" />
        </div>
        <div className="text-gray-600">
          {typeof message === 'string' ? message : String(message)}
        </div>
      </div>
    </div>
  );
}

export default ErrorState;
